import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Suspense, useEffect } from "react"
import {
  Route,
  BrowserRouter as Router,
  Routes,
  redirect
} from "react-router-dom"
import "./App.css"
import Layout from "./components/layout/Layout"
import { AuthStatus, useAuth } from "./hooks/useAuth"
import Connexion from "./views/authent/Connexion"
import PractitionerPrivateRoute from "./views/authent/PractitionerPrivateRoute"
import PrivateRoute from "./views/authent/PrivateRoute"
import ResetPassword from "./views/authent/ResetPassword"
import ResetPasswordRequest from "./views/authent/ResetPasswordRequest"
import Files from "./views/files/Files"
import { StatsContainer } from "./views/stats/StatsContainer"
import Invitations from "./views/invitations/Invitations"

const queryClient = new QueryClient()

export const Loader = () => (
  <div className="grid h-screen place-items-center">
    <img src={"images/loading.svg"} className="App-loading" alt="loading" />
    <div>Loading...</div>
  </div>
)

const App = () => {
  const { status, authenticate } = useAuth()

  useEffect(() => {
    if (status === AuthStatus.Authenticated) {
      authenticate()
    } else redirect("/login")
  }, [status, authenticate])

  return (
    <Suspense fallback={<Loader />}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <Routes>
            <Route element={<Layout />}>
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <StatsContainer />
                  </PrivateRoute>
                }
              />
              <Route
                path="/files"
                element={
                  <PractitionerPrivateRoute>
                    <Files />
                  </PractitionerPrivateRoute>
                }
              />
              <Route
                path="/invitations"
                element={
                  <PractitionerPrivateRoute>
                    <Invitations />
                  </PractitionerPrivateRoute>
                }
              />
            </Route>
            <Route path="/login" element={<Connexion />} />
            <Route
              path="/reset-password-request"
              element={<ResetPasswordRequest />}
            />
            <Route path="/reset" element={<ResetPassword />} />
          </Routes>
        </Router>
      </QueryClientProvider>
    </Suspense>
  )
}

export default App
